(ns practitest.frontend.permutations.main
  (:require [practitest.frontend.permutations.views :as views]
            [practitest.frontend.permutations.subs]
            [practitest.frontend.permutations.events]
            [practitest.frontend.common-old-fe.i18n :as i18n]
            [re-frame.core :as re-frame]
            [re-frame.db]))

(defn permutations-view []
  [views/main-panel])

(defn ^:export legacy-init [config translation]
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:permutations/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [:permutations/get-data]))